<template>
  <div>
    <div
      class="flex flex-col gap-4 text-left"
      v-if="selectedFilterType == 'fecha'"
    >
      <div>
        <label>Fecha Inicial</label>
        <input
          type="date"
          :value="selectedFilter.fecha ? selectedFilter.fecha[0] : ''"
          @change="(e) => $emit('change-date', 'inicio', e.target.value)"
        />
      </div>
      <div>
        <label>Fecha final</label>
        <input
          type="date"
          :value="selectedFilter.fecha ? selectedFilter.fecha[1] : ''"
          @change="(e) => $emit('change-date', 'final', e.target.value)"
        />
      </div>

      <button
        class="btn-borrar text-white ml-auto mt-auto"
        type="button"
        @click="() => $emit('remove', selectedFilterType)"
      >
        <fas :icon="['fas', 'trash']" />
      </button>
    </div>

    <div
      class="flex flex-col text-left"
      v-if="selectedFilterType == 'ref_cliente'"
    >
      <label>Referencia cliente</label>
      <div class="flex flex-row items-center gap-2">
        <input
          type="text"
          @change="(event) => $emit('change-value', selectedFilterType, event?.target?.value)"
          required
        />

        <button
          class="btn-borrar text-white mt-auto"
          type="button"
          @click="() => $emit('remove', selectedFilterType)"
        >
          <fas :icon="['fas', 'trash']" />
        </button>
      </div>
    </div>

    <div
      class="flex flex-col text-left"
      v-if="selectedFilterType == 'cliente_id'"
    >
      <label>Cliente</label>

      <div class="flex flex-row items-center gap-2 w-full">
        <Select2
          class="mi-select2 w-full"
          @change="(value) => $emit('change-value', selectedFilterType, value)"
          :options="clientList"
          :settings="{
            noResults: 'es',
            placeholder: 'Seleccione un Cliente',
            width: '100%',
            multiple: false,
          }"
        />

        <button
          class="btn-borrar text-white mt-auto"
          type="button"
          @click="() => $emit('remove', selectedFilterType)"
        >
          <fas :icon="['fas', 'trash']" />
        </button>
      </div>
    </div>

    <div
      class="flex flex-col text-left"
      v-if="selectedFilterType == 'nombre_nave'"
    >
      <label>Nombre de nave</label>

      <div class="flex flex-row items-center gap-2 w-full">
        <input
          type="text"
          @change="(value) => $emit('change-value', selectedFilterType, value)"
        />

        <button
          class="btn-borrar text-white mt-auto"
          type="button"
          @click="() => $emit('remove', selectedFilterType)"
        >
          <fas :icon="['fas', 'trash']" />
        </button>
      </div>
    </div>

    <div
      class="flex flex-col text-left"
      v-if="selectedFilterType == 'numero_manifiesto'"
    >
      <label>Número de Manifiesto</label>

      <div class="flex flex-row items-center gap-2 w-full">
        <input
          type="text"
          @change="
            (event) =>
              $emit('change-value', selectedFilterType, event.target?.value)
          "
          required
        />

        <button
          class="btn-borrar text-white mt-auto"
          type="button"
          @click="() => $emit('remove', selectedFilterType)"
        >
          <fas :icon="['fas', 'trash']" />
        </button>
      </div>
    </div>
    <div
      class="flex flex-col text-left"
      v-if="selectedFilterType == 'numero_documento_transporte'"
    >
      <label>Número de Documento de Transporte</label>

      <div class="flex flex-row items-center gap-2 w-full">
        <input
          type="text"
          @change="
            (event) =>
              $emit('change-value', selectedFilterType, event.target?.value)
          "
          required
        />
        <button
          class="btn-borrar text-white mt-auto"
          type="button"
          @click="() => $emit('remove', selectedFilterType)"
        >
          <fas :icon="['fas', 'trash']" />
        </button>
      </div>
    </div>

    <div class="flex flex-col text-left" v-if="!isFilterWithSelector">
      <label class="w-full text-left">{{ selectedFilter.text }}</label>
      <div class="flex flex-row w-full items-center gap-2">
        <select
          @change="
            (event) =>
              $emit('change-value', selectedFilterType, event.target.value)
          "
          required
        >
          <option
            v-for="option in options"
            :key="option.key"
            :value="option.key && option.value ? option.key : option"
          >
            {{ option.value ? option.value : option.key ?? option }}
          </option>
        </select>

        <button
          class="btn-borrar text-white mt-auto"
          type="button"
          @click="() => $emit('remove', selectedFilterType)"
        >
          <fas :icon="['fas', 'trash']" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  emits: ["remove", "change-date", "change-value"],
  props: {
    selectedFilter: {
      type: Object,
      default: () => ({}),
    },
    filterTypes: Array,
  },
  computed: {
    selectedFilterType() {
      return this.selectedFilter?.type || "";
    },
    isFilterWithSelector() {
      return (
        this.selectedFilterType == "fecha" ||
        this.selectedFilterType == "ref_cliente" ||
        this.selectedFilterType == "cliente_id" ||
        this.selectedFilterType == "nombre_nave" ||
        this.selectedFilterType == "numero_manifiesto" ||
        this.selectedFilterType == "numero_documento_transporte"
      );
    },
  },
  data() {
    return {
      options: [],
      clientList: [],
    };
  },
  async mounted() {
    if (this.selectedFilter?.type == "cliente_id") {
      const clientList = await this.fetchListable(this.selectedFilter.query);
      this.clientList = this.parseClients(clientList.clientes);

      this.$emit(
        "change-value",
        this.selectedFilterType,
        this.clientList[0].id
      );
    } else {
      const data = await this.fetchListable(this.selectedFilter.query);

      if (data && data[this.selectedFilter?.query]) {
        this.options = data[this.selectedFilter?.query];

        const defaultSelected = data[this.selectedFilter?.query][0]?.key
          ? data[this.selectedFilter?.query][0]?.key
          : data[this.selectedFilter?.query][0];

        this.$emit("change-value", this.selectedFilterType, defaultSelected);
      }
    }
  },
  methods: {
    async fetchListable(listable) {
      let query = {
        params: {
          get: `["${listable}"]`,
        },
      };

      const { data } = await axios.get(`/api/list`, query);

      if (data?.data) {
        return data.data;
      } else {
        return [];
      }
    },
    parseClients(clients) {
      if (clients?.length > 0) {
        return clients.map((client) => ({
          id: client.key,
          text: client.value,
        }));
      } else {
        return [];
      }
    },
  },
};
</script>
